import { AccountDescription } from "portal/components/users/AccountDescription";
import { Button } from "@mui/material";
import { Page } from "portal/components/Page";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import { WHITE_BUTTON } from "portal/theme/theme";
import PermissionDeniedIcon from "@mui/icons-material/LockOutlined";
import React, { FunctionComponent } from "react";

export const UnauthorizedPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const { user } = useSelf();
  const { logout } = useAuth0();

  return (
    <Page>
      <div className="self-center w-full max-w-96 p-4 h-full flex flex-col items-center justify-center text-gray-200 gap-4 text-center">
        <PermissionDeniedIcon className="text-6xl" />
        <strong>{t("views.page.unauthorized.errorTitle")}</strong>
        <div>{t("views.page.unauthorized.errorDetails")}</div>
        {user && (
          <div className="text-gray-400 text-sm">
            {t("views.page.unauthorized.loggedInAs")}
            <AccountDescription user={user} className="text-sm" />
          </div>
        )}
        <Button
          {...WHITE_BUTTON}
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
        >
          {t("views.settings.logOut")}
        </Button>
      </div>
    </Page>
  );
};
